import './ccf-twitter-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfTwitterIconProps extends SvgIconProps { }

/**
 * Component display twitter icon 
 * @param props -CcfTwitterIconProps
 * @returns svg twitter icon
 * @example <CcfTwitterIcon/>
 */
export function CcfTwitterIcon(props: CcfTwitterIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g id="ic_Twitter">
        <g id="Channel_Type" data-name="Channel Type" transform="translate(3.702 3.702)">
          <g id="Icon_Interaction_Type" data-name="Icon Interaction Type" transform="translate(-6.403 -7)">
            <path id="Path_12741" data-name="Path 12741" d="M16.6,13.493a3.12,3.12,0,0,1-3.1,3.1H3.12A3.12,3.12,0,0,1,0,13.493V3.12A3.12,3.12,0,0,1,3.12,0H13.493a3.12,3.12,0,0,1,3.1,3.12ZM12.531,5.577a2.29,2.29,0,0,0,1.012-1.261,4.531,4.531,0,0,1-1.444.548,2.274,2.274,0,0,0-3.917,1.56,2.041,2.041,0,0,0,0,.515A6.456,6.456,0,0,1,3.519,4.564,2.29,2.29,0,0,0,3.2,5.709,2.241,2.241,0,0,0,4.182,7.6,2.722,2.722,0,0,1,3.1,7.319h0A2.307,2.307,0,0,0,4.979,9.56a1.909,1.909,0,0,1-.548.083H4.016A2.274,2.274,0,0,0,6.141,11.3a4.564,4.564,0,0,1-2.821.846H2.772a6.456,6.456,0,0,0,9.942-5.51,2.557,2.557,0,0,0,0-.3,4.365,4.365,0,0,0,1.129-1.178A4.846,4.846,0,0,1,12.531,5.577Z" transform="translate(6.403 7)" fill="#1da1f2" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfTwitterIcon;
